import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagGH(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURf3SO/3VRxCFUtAXLQ58TAx0R9cZMN4cMwtuQ+MdNeYfNx0cGu3GPxloPquQMWZYJCLqOvEAAAF9SURBVDjLzYyxbsIwEIYve1XgBVBV9QEqRWKuqmTvEEsZkSw5K1Miti6RGNmQM3WFVwgCMTdSX4HODG1nlt75TAK0OB37xWf/d/5iWLh5Aa11USwW87m2FEWTtZ6CdkPCjMmy8Xg2ozokuppCdsA4NtXDbNQIv4NCkqVIlhCcuDiPQKVKJfhhizFNMGFnZpjVEDDzhM7UnImyAU8juEBBqgEia5TplJ0MwR/4Ehdt9ElJm28ncnAPPiP9Y5quFi7xB6Hnpnsu9NuE102LsHtvEfZfLqGqqnJZVZsTwavp9t5KYr3pUWeBQ6CRtyNha4YeSwD4BHRx0VvQx/sVPWr+M1fgAS9s8NiZB8wI8JJPjnzsy/KzGf/kqlyVS3BwvYbOyiV0tgAfLuHK1jG3bm7+gfAAgRsU7vALHvGjnZZpuYzQ9kKIBEGE0B7iMi1XEDyBCAWBGh1RJGgQCS4hUDgiFOK8bYQYKz8VciNMiDyfxHkex5y548kzC5dpF74B5HKFNqWMz2kAAAAASUVORK5CYII=",
    alt: "GH"
  }, props));
}